// イラストカードセクション用SVG
import illustrationM10Svg from "../../../../public/images/illustrations/m_10_white.svg" with {
	type: "text",
};
import illustrationM11Svg from "../../../../public/images/illustrations/m_11_warmgray.svg" with {
	type: "text",
};
import illustrationM12Svg from "../../../../public/images/illustrations/m_12_white.svg" with {
	type: "text",
};
import illustrationM14Svg from "../../../../public/images/illustrations/m_14_white.svg" with {
	type: "text",
};

import iconAuthSvg from "../assets/icons/authentication_line.svg" with {
	type: "text",
};
import iconChildSvg from "../assets/icons/child_line.svg" with { type: "text" };
import iconFamilySvg from "../assets/icons/family_line.svg" with {
	type: "text",
};
import iconHealthSvg from "../assets/icons/health_line.svg" with {
	type: "text",
};
import iconHouseSvg from "../assets/icons/house_line.svg" with { type: "text" };
import iconMotherChildSvg from "../assets/icons/mother_and_child_line.svg" with {
	type: "text",
};

import illustrationPeopleSvgText from "../assets/illustration-people.svg" with {
	type: "text",
};
import bundledMainVisualSvgText from "../assets/main-visual.svg" with {
	type: "text",
};

export {
	bundledMainVisualSvgText,
	iconAuthSvg,
	iconChildSvg,
	iconFamilySvg,
	iconHealthSvg,
	iconHouseSvg,
	iconMotherChildSvg,
	illustrationM10Svg,
	illustrationM11Svg,
	illustrationM12Svg,
	illustrationM14Svg,
	illustrationPeopleSvgText,
};
